export default __webpack_public_path__ + "static/media/gat.9affb4a6.png";